import { doc, getDoc, getFirestore } from 'firebase/firestore';
import { firebaseApp } from './config';

const projectFirestore = getFirestore(firebaseApp);

export const getUserDocument = (userId) => getDoc(doc(projectFirestore, 'users', userId));
